import { NavLink, Outlet, useLocation } from "react-router";
import { cn } from "@cm/ui";
import { useSession } from "../lib/session";
import type { SectionTab } from "./nav";

/**
 * Abas de uma seção cujas telas têm endereços próprios (ex.: Configurações → Equipe, Workspaces…).
 * Mostra só as abas permitidas ao usuário (a autorização real continua no servidor) e renderiza a tela da rota.
 */
export function SectionTabs({ tabs, label }: { tabs: SectionTab[]; label: string }) {
  const { can, isPlatform } = useSession();
  const loc = useLocation();
  const visible = tabs.filter((t) => isPlatform || can(t.permission));
  const active = (t: SectionTab) => (t.end ? loc.pathname === t.to : loc.pathname === t.to || loc.pathname.startsWith(`${t.to}/`));
  return (
    <>
      {visible.length > 1 && (
        <nav aria-label={label} className="-mt-1 mb-5 flex gap-1 overflow-x-auto border-b border-border">
          {visible.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              aria-current={active(t) ? "page" : undefined}
              className={cn(
                "-mb-px whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium focus-visible:outline-2 focus-visible:outline-focus",
                active(t) ? "border-brand text-brand-700" : "border-transparent text-muted hover:text-fg",
              )}
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      )}
      <Outlet />
    </>
  );
}
